import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { CART_BOX_BUILDER_POPUP } from 'swag-client-common/constants';
import { withConditionalRendering } from 'swag-client-common/components/utils/with-conditional-rendering';
import { hideForLimitedBuyingCartView } from 'swag-client-common/redux/cart/cart.utils';
import { cartBuildABoxButtonLabelSelector, shouldShowBuildABoxButtonSelector } from '../../../../../../redux/cart/cart.selectors';
import { resetBoxBuilderState } from '../../../../../../redux/box-builder/box-builder.actions';
import { getAddonProductsForBox } from '../../../../../../redux/product/product.actions';
import BuildABoxCartButton from './build-a-box-cart-button';
const mapStateToProps = createStructuredSelector({
  cartBuildABoxButtonLabel: cartBuildABoxButtonLabelSelector,
  shouldShowBuildABoxButton: shouldShowBuildABoxButtonSelector
});
const mapDispatchToProps = dispatch => ({
  onClick: () => {
    dispatch(resetBoxBuilderState());
    dispatch(showPopup({
      popup: CART_BOX_BUILDER_POPUP
    }));
    dispatch(getAddonProductsForBox());
  }
});
export default withConditionalRendering(connect(mapStateToProps, mapDispatchToProps)(BuildABoxCartButton), hideForLimitedBuyingCartView);